/**
 * @module 固定値定義
 */
const CONSTANTS = {
  //----------------------------------------
  //共通
  //----------------------------------------
  PAGE_ANCESTOR_CODE: {
    TOP: 1,
    NOTIFICATION: 2,
    HOME_SECURITY: 3,
    CAMERA: 4,
  },
  LIST_PANEL_LABEL_WIDTH: {
    PC: 235,
    SP: 165,
  },
  // 利用プラン（ホームセキュリティ）
  HOME_SECURITY_USAGE_PLAN: {
    // オンライン監視プラン
    ONLINE_MONITORING_PLAN: 0,
    // 依頼かけつけプラン
    EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN: 1,
    EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE: 2,
    // セルフ監視プラン
    SELF_MONITORING_PLAN: 3,
    SELF_MONITORING_PLAN_NO_DEVICE: 4,
  },
  // 利用プラン（カメラ）
  CAMERA_USAGE_PLAN: {
    // オンライン監視プラン
    ONLINE_MONITORING_PLAN: 0,
    // 依頼かけつけプラン
    EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN: 101,
    // セルフ監視プラン
    SELF_MONITORING_PLAN: 102,
  },

  //----------------------------------------
  // FE-CU08_ホームセキュリティ画面
  // FE-CU09_対象地区詳細画面
  // FE-CU17_通知履歴画面
  // FE-CU25_カメラ画面
  // FE-CU26_カメラ詳細画面
  //----------------------------------------
  // 信号一覧
  NOTIFICATION_HISTORY: {
    // 内容種別 1：異常/発生
    CONTENTS_TYPE1: {
      // サービス種別
      SERVICE_TYPE: {
        N01: 'red',
        A01: 'red',
        A02: 'red',
        A19: 'red',
        A03: 'red',
        A04: 'red',
        A09: 'red',
        A05: 'blue', // yellow
        A06: 'blue', // yellow
        A07: 'blue', // yellow
        A08: 'blue', // yellow
        A10: 'blue', // yellow
        A11: 'blue', // yellow
        A12: 'blue', // yellow
        A17: 'blue', // yellow
        A18: 'blue', // yellow
        A15: 'blue', // yellow
        A16: 'blue', // yellow
        A13: 'blue', // yellow
        A14: 'blue', // yellow
        M02: 'blue', // yellow
        M03: 'blue', // yellow
        J02: 'red',
        J04: 'red',
        J06: 'red',
        J10: 'blue', // yellow
        J11: 'red',
        J13: 'blue', // yellow
        C001: 'blue', // yellow
        C002: 'blue', // yellow
        C003: 'blue', // yellow
      },
    },
    // 内容種別 0：正常/復旧
    CONTENTS_TYPE0: {
      // サービス種別
      SERVICE_TYPE: {
        A01: 'blue',
        A02: 'blue',
        A19: 'blue',
        A03: 'blue',
        A04: 'blue',
        A09: 'blue',
        A05: 'blue',
        A06: 'blue',
        A07: 'blue',
        A08: 'blue',
        A10: 'blue',
        A11: 'blue',
        A12: 'blue',
        A17: 'blue',
        A18: 'blue',
        A15: 'blue',
        A16: 'blue',
        A13: 'blue',
        A14: 'blue',
        S03: 'blue',
        S05: 'blue',
        S04: 'blue',
        S06: 'blue',
        S07: 'blue',
        S08: 'blue',
        M02: 'blue',
        M03: 'blue',
        J01: 'blue',
        J03: 'blue',
        J05: 'blue',
        J07: 'blue',
        J08: 'blue',
        J09: 'blue',
        J16: 'blue',
        J12: 'blue',
        J14: 'blue',
        J15: 'blue',
        C002: 'blue',
        C003: 'blue',
      },
    },
    // ユーザー警備
    USER_SECURITY: {
      HSAPP1: 'blue',
      HSAPP2: 'blue',
      HSAPP3: 'blue',
      HSAPP4: 'blue',
      HSAPP5: 'blue',
    },
    // ALSOKからのお知らせ
    ALSOK: 'green',
  },

  //----------------------------------------
  // FE-CU42_緊急連絡先設定画面
  // FE-CU43_緊急連絡先設定画面-同居家族情報
  // FE-CU44_緊急連絡先設定画面-救急情報
  // FE-CU45_救急情報設定画面
  //----------------------------------------
  // タブタイプ
  TAB_TYPE: {
    // 緊急連絡先
    EMERGENCY_CONTACT: 1,
    // 同居家族情報
    FAMILY_MEMBERS_INFORMATION: 2,
    // 救急情報
    FIRST_AID_INFORMATION: 3,
  },
  // 画面タイプ（遷移元で決定）
  DISPLAY_TYPE: {
    // ホームセキュリティ（対象地区）
    HOME_SECURITY: 1,
    // カメラ
    CAMERA: 2,
  },
  // 処理区分
  PROCESS_TYPE: {
    // 追加
    ADD: 1,
    // 変更
    CHANGE: 2,
    // 削除
    DELETE: 3,
    // 並べ替え
    SORT: 4,
  },
  // 登録上限
  REGISTRATION_LIMIT: {
    // 緊急連絡先
    EMERGENCY_CONTACT: 5,
    // 同居家族情報
    FAMILY_MEMBERS_INFORMATION: 7,
    // 救急情報
    FIRST_AID_INFORMATION: 2,
  },
  // JIS規格
  JIS: {
    // JIS X 0208に含まれる全ての文字(6,879文字)
    JIS_X_0208:
      '　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓０１２３４５６７８９ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをんァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя亜娃阿哀愛挨姶葵茜穐悪握渥旭葦梓圧斡扱宛姐虻絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依囲夷委威尉惟意慰易椅為畏異移維胃萎衣謂遺医井亥域育郁磯一壱逸稲茨芋允印咽員因姻引飲胤蔭院陰隠韻吋右宇烏羽雨卯鵜窺丑碓臼渦嘘唄蔚鰻姥浦瓜閏云運雲荏叡営嬰影映曳栄永泳洩瑛盈穎頴英詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴怨掩援演炎煙燕猿縁艶苑薗遠鴛塩於汚甥凹央奥往応押旺横欧殴王黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨過霞蚊俄峨我牙画臥蛾賀餓駕介会解回塊壊廻快怪悔懐戒改魁械海灰界皆絵芥蟹開階貝凱劾外咳害崖涯碍蓋街該鎧骸浬馨蛙垣柿鈎劃嚇各廓拡格核獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割恰括活渇滑褐轄且鰹叶椛樺株兜蒲釜鎌鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換柑桓棺款歓汗漢環甘監看竿管簡緩缶肝艦莞観還鑑間閑関陥韓館舘丸含岸玩癌眼岩贋雁顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄機毅気汽畿祈季稀紀規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供僑兇競共凶協匡叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝暁業局曲極玉桐粁勤巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦駆駈駒具愚虞空偶寓遇隅串釧屈掘窟沓轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈係傾刑兄啓圭珪型契形径恵慶憩掲携敬景桂渓畦系経継罫茎蛍計詣警軽鶏芸迎鯨劇戟撃激桁欠決潔結血訣月件倹兼券剣喧圏堅憲懸拳検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験元原厳幻弦減源玄現絃舷言限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨雇顧鼓五互伍午呉吾娯後御悟梧瑚碁語誤護醐乞鯉佼侯候倖光功効勾厚口向后喉坑垢好孔孝宏工巧幸広庚康弘恒慌抗拘控攻晃杭梗構江洪浩港甲皇稿糠紅紘綱耕肯肱腔膏航荒行衡講貢郊酵鉱鋼閤項香高鴻剛劫号合壕濠豪轟克刻告国穀酷黒獄漉腰忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災犀砕砦祭斎細菜裁載際剤在材財坂阪堺肴咲崎埼碕鷺作削咋搾昨朔窄策索錯桜鮭笹匙冊刷察拶撮擦札殺雑皐鮫皿晒三傘参山惨撒散桟燦産算纂蚕讃賛酸餐斬暫残仕仔伺刺司嗣四士始姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝縞舎写射捨赦斜煮社紗者車蛇借勺尺爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚周宗就州修愁拾洲秀秋終習臭舟蒐衆襲讐蹴週酬集醜什住充十従戎汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春竣駿准循旬殉淳準潤盾純巡遵醇順処初所暑庶緒署書諸助叙女序徐恕鋤除傷償勝匠升召商唱嘗奨妾娼宵将小少尚庄床彰承抄招掌捷昇昌昭晶樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蕉衝裳証詔詳象賞鉦鍾鐘障上丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱飾拭殖燭織色触食辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣笥諏須酢図厨吹垂帥推水炊睡粋衰酔錐錘随瑞髄崇嵩数枢趨雛杉椙菅頗雀裾澄寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接折設窃節説雪絶舌仙先千占宣専尖川戦扇栴泉浅洗染潜旋穿箭線繊羨腺舛薦践選遷銭銑閃鮮前善漸然全禅繕膳糎塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻鼠僧双叢倉喪壮奏爽宋層匝惣想捜掃挿操早曹巣槍槽漕燥争相窓糟綜草荘葬蒼藻装走送遭鎗霜騒増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村他多太汰詑唾堕妥惰打柁舵楕陀駄体堆対耐岱帯待怠態戴替泰滞胎苔袋貸退逮隊鯛代台大第醍題鷹滝瀧卓宅托択拓沢託鐸濁諾茸凧只叩但達辰奪脱竪谷狸誰丹単嘆坦担探旦歎淡湛炭短端綻耽胆蛋鍛団壇弾断暖檀段男談値知地弛智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷酎鋳駐樗猪苧著貯丁喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町脹腸蝶調諜超銚長頂鳥勅直朕沈珍賃鎮陳津墜椎追痛通栂槻佃漬柘蔦綴鍔椿潰坪嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底弟悌抵挺提梯汀碇禎程締訂諦蹄逓邸釘鼎泥摘敵滴的笛適鏑哲徹撤轍迭鉄典天展店添纏甜貼転点伝殿澱田電兎吐塗妬徒斗杜渡登途都鍍砥努度土奴怒倒党冬凍刀唐塔套宕島嶋悼投搭東棟盗淘湯灯燈当痘等答筒糖統到董蕩藤討謄豆踏透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠匿得徳特督禿篤毒独読栃橡凸突椴届鳶苫寅酉屯惇敦沌豚呑曇鈍奈内乍凪薙捺鍋馴縄畷南楠軟難汝二尼弐匂賑肉虹廿日乳入如尿韮任妊忍認濡祢寧葱猫熱年念捻撚燃粘乃廼之埜悩濃納能脳膿農覗蚤巴把播覇杷波琶破婆罵芭馬俳廃拝敗杯盃背肺配倍培媒梅楳煤狽買売賠陪矧萩伯博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲肇筈櫨幡肌畑畠八鉢発髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯畔繁般藩販範釆煩飯晩番盤磐蕃蛮匪卑否妃庇彼批披比泌疲皮碑秘罷肥被費避非飛簸備尾微枇毘琵眉美鼻匹疋髭彦膝菱肘弼必畢筆姫紐百俵彪標氷漂瓢票表評豹描病秒苗錨鋲蒜蛭鰭品彬斌浜賓敏瓶不付埠夫婦富冨布府怖扶敷斧普浮符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風蕗伏副復幅服福腹複覆淵弗払沸仏物鮒吻墳扮焚奮糞文聞丙併兵塀幣平弊柄並閉陛米頁僻壁癖碧別蔑箆偏変片篇編辺返遍勉弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩抱放方朋法烹砲縫胞芳萌蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡摩磨魔麻埋妹昧枚毎哩幕膜枕鮪柾亦俣又抹末沫繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面摸模茂妄孟毛猛盲網耗蒙木黙目杢勿尤戻貰問悶紋門匁也冶夜爺野弥矢厄役約薬訳躍靖柳愉油諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶用窯羊葉蓉要謡踊陽養慾抑欲沃浴翌淀羅螺裸来頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒量陵領力緑倫厘林淋燐琳臨輪鱗瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊齢暦歴列劣烈裂廉恋憐簾練連錬呂魯櫓炉賂路露労婁廊弄朗楼浪漏牢狼老郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀碗腕弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傴傲僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兢竸兩兪兮冀冂囘册冏冑冖冦冢冩冪冫决冱冲冰况冽凅凉几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匚匣匯匱匳匸卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢啀啣啌售啜啅啖啗唸啝喙喀咯喊喟啻啾喘喞單啼喃喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚮嚶嚴囂嚼囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堙堝塲堡塢塋塰毀塒堽塹墅墹墟墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩奸妁妝佞侫妣妲姆姨姜妍姙娥娟娑娜娉娚婀婬婉娵婢婪媚媼嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵋嵬嵳嵶嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巍巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悒悧悋惡悸惠惓悴忰悽惆悵慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼戀戈戉戍戌戔戛戞戡截戮戰戲戳扁扎扞扣扛扠扼抂抉找抒抓抖拔抃抔拗拑抻拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫掾揩揀揆揣揉插揶揄搖搴搓搦搶搗搨摧摯摶摎撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擺攀擽攘攜攤攣攫攴攵攷收攸畋效敖敕敍敘敞敲數斂變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晢晰暃暈暎暉暄暘暝曁暹曉暾暼曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰杼杪枌枋枡枅枷柯柬枳柩枸柤柞柝柢柮枹柎柆栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梃梹桴梵梠梺椏桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楔楾楮椹楴椽楙楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓樌橲樶橸橇橢橙橦橈樸樢檍檠檄檢檣檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭渮渙湲湟渾湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁滬滸漿滲漱滯漲滌漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹爍爐爛爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳玻珀珮珞璢琅瑯琥珸琺瑕琿瑙瑁瑜瑩瑰瑣瑪瑾璋璞璧瓊瓏瓔珱瓣瓧瓩瓮瓲瓰瓱瓸瓷甃甅甎甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癶癸發皀皃皈皋皎皖皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒砠硅碎硴碆碚碌碣碵碪碯磑磆磋碾碼磅磊磬磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹秉秕秧秬秡秣稈稍稘稠稟禀稻稾稷穃穗穉穡穢穩穰穹穽窈窗窘窖窩窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝篋篁篌篏箴篆篝篩簑簔篦篥簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粤粭粢粫粡粨粳粲粱粹粽糀糅糂糘糒糜糢鬻糯糴糶糺紆紂紜紕紊絅絋紮紲紿紵絆絖絎絲絨絮絏絣經綉絛綏絽綺綣綵緇綽綫總綢綯緜綸綰緘緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聢聨聲聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋隋腆脾腑胼腱腮腥腦腴膃膈膀膂膠膕膤膣腟膓膩膰膾膸膽臀臂膺臉臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫艱艷艸艾芒芫芟芻芬苡苣苟苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖莎莇莊荼莵荳莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈蕁蕋薀薤薈薑薊薨蕭薔薛薇薜蕷蕾薐藉薺藏薹藐藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蚫蛔蛞蛩蛬蛟蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪螢螟螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蠑蠖蠕蠢蠡蠱蠹蠧蠻衄衂衒衙衞衢衫袁衾衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裙裝裹褂裼裨裲褄褌褓襃褞褥褪襁襄褶褸襌褝襠襞襦襤襭襴襷襾覃覈覊覓覘覡覩覦覬覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諳諧諤諱謔諠諢諷諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賣賚賽賺賻贄贊贇贍贐贓賍贔贖赧赭赱赳趁趙跂趾趺跏跖跌跛跋跪跫跟跣跼踈跿踝踞踐踟蹂踵踰踴蹊蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躔躙躪躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迯迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遉逾遖遞遨遯遶隨遲邂遽邁邀邊邏邨邯邱邵郢郤郛鄂鄒鄙鄲酊酣酩醋醉醂醫醵釀釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霪霰霹霾靄靆靈靂靉靜靤靦靨勒靫靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頡頷頽顆顏顋顫顯顰顱顴颪颯颱颶飄飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬯鬲魄魃魏魎魑魘魴鮓鮃鮑鮖鮟鮠鮨鮴鯀鯊鮹鯏鯑鯒鯣鯢鯤鯔鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鴣鴟鵄鴕鴒鵁鴿鴾鵆鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龠∈∋⊆⊇⊂⊃∪∩∧∨￢⇒⇔∀∃∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬Å‰♯♭♪†‡¶◯─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂唖逢芦鯵飴溢鰯淫迂欝噂焔襖鴬鴎迦恢拐晦蛎撹喝葛鞄竃噛澗潅翰諌翫徽祇侠卿尭僅躯喰櫛屑靴祁慧稽繋荊頚隙倦嫌捲鹸諺巷昂溝砿麹鵠甑采冴榊柵薩鯖捌錆珊屡蕊遮杓灼繍酋曙渚薯藷哨廠梢蒋醤鞘蝕靭逗翠摺逝蝉撰栓煎煽詮賎噌遡創掻痩遜騨腿黛啄濯琢蛸巽辿棚鱈樽箪註瀦凋捗槌鎚塚掴辻壷鄭擢溺填顛堵屠菟賭砺塘梼涛祷鴇涜瀞噸遁頓那謎灘楢迩禰嚢牌這蝿秤剥箸溌醗挽樋柊稗逼桧媛謬廟瀕頻瞥娩庖泡蓬頬槙鱒迄侭麺儲餅籾薮鑓愈癒猷熔耀遥莱遼漣煉蓮榔篭蝋儘兔冉冕冤唹唳嘲嚥堋壺寃屏悗捩搆攪攅斃枦枴檜梛檮梍濤湮灌爨珎瑶甄甍甕皓礦硼稱龝竈箙籠粐粮綛綮綟翔舮芍苒茣荵蔗蘂藪蠣蛛蠅螂蟒褊覯諫諞譁賤跚踉輓迪邇遘邉扈釁霤頸頤鬮鮗鰺鯲鶯麪龜堯槇遙瑤偉緯違衛延沿鉛翁芽雅慨殻敢貫巌頑帰窮均傑穴健建鈷檎交公更校硬絞考購降拷罪使史姉謝邪収輯柔瞬舜楯松訟丈埴植職親遂据摂船総聡像誕恥兆眺聴跳庭廷艇桃逃派排輩班頒悲斐緋誹貧父葺分噴憤粉紛雰便捧盆桝脈耶翼吏隣麟麗聯聾湾傅冓凛匕區雙喩囁圍墫姚娶嵎嶇巉巓弭徘惘愽懾扨拏攝搏擲敝晟枩柧楫椰榧橄檐氈氓渣漑滾漾煕燿珥琲瑟瓠甌癲磔禺稙窕糲絳緝縵翡聚聟聳聰聶腓膊膵臍菲蕕藕蜚蠶袞裘裴褫褻襪襯訝豕贅贏齎躑躡遒逎鄰酖酘酥酳酲醢醯醪醴醺鑷隘霽頌顳飃驅魍鯆鯡鯱鵈鷏鼈凜熙厩餌概扉蔽媾礪靠靱ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮｰｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟｳﾞ',
  },
  // 正規表現パターン
  REGULAR_EXPRESSION: {},
  DAY_OF_THE_WEEK: {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
  },
  //----------------------------------------
  // FE-CU46_サービス追加画面
  //----------------------------------------
  // 追加するサービス
  SERVICE_TO_ADD: {
    HOME_SECURITY: 1,
    CAMERA: 2,
    OTHER_SERVICES: 3,
  },

  //----------------------------------------
  // FE-CU47_ユーザー情報変更画面（氏名, 電話番号）
  // FE-CU53_ユーザー登録画面（本登録）
  //----------------------------------------
  // 生年の最小値
  MIN_BIRTH_YEAR: 1900,
};

export default CONSTANTS;
